module.exports = "<div class=\"container-fluid\">\r\n  <div class=\"jumbotron text-center\">\r\n    <h1>\r\n      <span translate>APP_NAME</span>\r\n    </h1>\r\n    <p>\r\n      <i class=\"fa fa-bookmark-o\"></i> <span translate>Version</span> {{version}}\r\n    </p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/about/about.component.html
// module id = ../../../../../src/app/about/about.component.html
// module chunks = main